var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "375.99 619.69 868.38 100.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-301.742 -519.877)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-351.15 -473.375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-387.778 -525.578)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-394.484 -460.967)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-446.911 -483.883)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-507.423 -475.797)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-542.741 -523.677)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-571.433 -525.578)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-606.607 -525.578)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-641.037 -525.578)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-676.21 -525.578)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-715.447 -512.91)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-754.683 -525.578)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-840.458 -473.375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-868.031 -512.91)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0Z",
    transform: "translate(-910.473 -481.312)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 3.279-1.528 4.931-4.583 4.956h-.075c-3.031 0-4.546-1.653-4.546-4.956v-44.713c0-3.305 1.528-4.956 4.583-4.956 3.08 0 4.621 1.651 4.621 4.956zm10.545-44.713c0-10.235-5.055-15.364-15.166-15.39-10.085 0-15.128 5.129-15.128 15.39V0c0 10.234 5.043 15.352 15.128 15.352C5.49 15.352 10.545 10.234 10.545 0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 402.322 640.164)",
    clipPath: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-9.043-5.055-13.575-15.166-13.601-10.085 0-15.127 4.534-15.127 13.601v52.091h10.545V0c0-2.907 1.527-4.359 4.582-4.359 3.081 0 4.621 1.452 4.621 4.359v52.091H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 468.2 702.167)",
    clipPath: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-9.166h-9.874v-55.445h-10.545v55.445h-9.874V0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 517.037 632.563)",
    clipPath: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v64.611h10.545V9.203H27.35V0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 525.98 718.71)",
    clipPath: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4.024 26.902L-8.049 0Zm10.657 0 3.428-22.916H3.428L1.378-9.204H-9.39l-2.086-13.712h-10.62l3.429 22.841 7.452 41.77H3.242Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 595.881 688.156)",
    clipPath: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 7.453 49.781h10.656l-3.427-22.916L7.267-14.83H-7.191l-5.478 33.35-5.439-33.35h-14.457l-7.453 41.77-3.428 22.841h10.619L-25.375 0l7.453 49.781h10.47z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 676.564 698.937)",
    clipPath: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-52.315h4.62c3.056 0 4.583 1.652 4.583 4.956v42.366C9.203-1.664 7.676 0 4.62 0Zm-10.545 10.396H5.701c9.364-.025 14.047-5.155 14.047-15.389v-42.366c0-10.209-4.905-15.327-14.718-15.351h-15.575z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 723.655 635.097)",
    clipPath: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h27.349v-9.166H10.545v-18.519h14.457v-9.24H10.545v-18.483h16.804v-9.203H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 761.91 632.563)",
    clipPath: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h27.35v-9.166H10.545v-18.519h14.457v-9.24H10.545v-27.686H0z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 808.81 632.563)",
    clipPath: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h27.349v-9.166H10.545v-18.519h14.457v-9.24H10.545v-18.483h16.804v-9.203H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 854.716 632.563)",
    clipPath: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h10.545l9.985-37.484V0h9.763v-64.611H19.748l-9.613 36.292v-36.292H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 901.615 632.563)",
    clipPath: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 9.042 5.043 13.563 15.128 13.563 10.109 0 15.165-4.521 15.165-13.563v-8.682H19.748V0c0 2.906-1.527 4.359-4.583 4.359h-.074c-3.03 0-4.546-1.453-4.546-4.359v-5.851c0-2.881 3.291-6.408 9.874-10.582 6.583-4.148 9.874-9.129 9.874-14.941v-8.16c0-9.068-5.043-13.601-15.128-13.601C5.054-53.109 0-48.577 0-39.534v8.681h10.545v-8.681c0-2.907 1.54-4.36 4.62-4.36 3.056 0 4.583 1.453 4.583 4.36v7.378c0 3.13-3.291 6.781-9.874 10.955C3.291-17.054 0-12.011 0-6.074Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 953.93 649.454)",
    clipPath: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h27.35v-9.166H10.545v-18.519h14.458v-9.24H10.545v-18.483H27.35v-9.203H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 1006.244 632.563)",
    clipPath: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.484 473.076h12.111v-12.109h-12.111z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 0 1333.333)",
    clipPath: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-9.043-5.056-13.575-15.165-13.601-10.085 0-15.128 4.534-15.128 13.601v39.534c0 9.042 5.043 13.563 15.128 13.563C-5.056 53.097 0 48.576 0 39.534v-8.682h-10.545v8.682c0 2.906-1.527 4.36-4.583 4.36h-.074c-3.03 0-4.546-1.454-4.546-4.36V0c0-2.907 1.527-4.359 4.583-4.359 3.079 0 4.62 1.452 4.62 4.359v8.682H0Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 1120.61 702.167)",
    clipPath: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 2.906-1.527 4.359-4.583 4.359h-.074c-3.031 0-4.546-1.453-4.546-4.359v-39.534c0-2.907 1.527-4.36 4.582-4.36 3.08 0 4.621 1.453 4.621 4.36zm10.545-39.534c0-9.043-5.056-13.575-15.166-13.601-10.084 0-15.127 4.533-15.127 13.601V0c0 9.042 5.043 13.563 15.127 13.563 10.11 0 15.166-4.521 15.166-13.563z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 1157.375 649.454)",
    clipPath: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 12.259 44.266h10.545v-64.611H12.705v36.256L3.688-20.345h-7.153l-9.278 36.256v-36.256h-10.21v64.611h10.545z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 1213.964 691.585)",
    clipPath: "url(#q)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextLogoWhite);
export default __webpack_public_path__ + "static/media/TextLogoWhite.778a999bf61d5e76cab17dc1ae6dfa72.svg";
export { ForwardRef as ReactComponent };